export default {"src":"/_next/static/media/quiz-tell-us.6f62af6a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};